export default __webpack_public_path__ + "static/media/card.f5799471.png";